import styled, { css } from 'styled-components'

export const PageContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media screen and (max-width: 1040px) {
    padding: 0 16px;
  }
`

export const WrapperTitle = styled.div`
  font-family: var(--primary-font);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  color: var(--gray-2);
  margin-top: 32px;
  @media screen and (max-width: 1040px) {
    margin-bottom: 24px;
  }

  ${({ isServices }) => isServices && css`
    font-size: 16px;
    line-height: 19.2px;
  `}

  ${({ hasSelectedPet }) => hasSelectedPet && css`
    @media screen and (max-width: 1200px) {
      display: none;
    }
  `}
`

export const AlignWrappers = styled.div`
  width: 100%;
  max-width: 752px;
  margin-left: 16px;
  @media screen and (max-width: 1200px) {
    margin-left: 0;
  }
`

export const Price = styled.div`
    font-family: var(--primary-font);
    font-weight: 600;
    line-height: 145%;
    display: ${props => props.campaign ? 'flex' : 'block'};
    font-size: ${props => props.campaign ? '16px' : '13px'};
    margin-top: ${props => props.marginTop ? '4px' : '0px'};
    color: ${props => props.previousPrice ? 'var(--gray-5)' : 'var(--gray-2)'};
    ${props => props.previousPrice && 'text-decoration: line-through; font-weight: 400;'};

    ${({ price }) => price && css`
      color: var(--gray-5);
      font-size: 14px;
    `}
`

export const DiscountAmount = styled.div`
    background: var(--the-white);
    border-radius: 8px;
    margin-left: 8px;
    padding: 2px 8px;
    color: var(--success);
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 17.7px;
    border: 1px solid var(--success);
`

export const CalcPrice = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
    color: var(--gray-2);
    margin: 40px 0 24px 0;
    padding: 0 24px;
`
export const Total = styled.div`
    margin-left: auto;
    text-align: right;
    font-weight: 600;
    font-size: ${props => props.previousPrice ? '16px' : '20px'};
    ${props => props.previousPrice && 'text-decoration: line-through; margin-bottom: 4px;'};
`
